/**
 * Error thrown by `HttpService` for any failed request.
 *
 * The HTTP state of the original `HttpErrorResponse` is kept in the error, so consumers can still
 * react to it: the API interceptor decides whether the backend rejected the session, and the auth
 * forms show a specific message for a 400. Losing it (as a plain `Error` did) made those checks
 * always fail.
 */
export class HttpRequestError extends Error {
  constructor(
    message: string,
    public readonly status?: number,
    public readonly statusText?: string,
    public readonly url?: string,
  ) {
    super(message);
    this.name = 'HttpRequestError';
  }
}
